import './mainContainer.css'
import {Post} from '../../features/post/post'



export const MainContainer = () => {


  return (
    <div className= 'mainContainer'>
      <Post />
    </div>
  )
}